import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";

const FeeStructurePage = () => {
  const { feeStructureId } = useParams();
  const navigate = useNavigate();
  const [feeStructure, setFeeStructure] = useState(null);
  const printRef = useRef(null);

  useEffect(() => {
    const sessionId = localStorage.getItem("currentSessionId");

    if (!feeStructureId || !sessionId) {
      alert("Session or Fee Structure missing");
      navigate(-1);
      return;
    }

    axios
      .get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/getFeeStructureById/${feeStructureId}/${sessionId}`
      )
      .then((res) => {
        setFeeStructure(res.data);
      })
      .catch((err) => {
        console.error("Error fetching fee structure:", err);
        alert("Fee Structure not found");
        navigate(-1);
      });
  }, [feeStructureId, navigate]);

  const handlePDF = () => {
    if (!feeStructure) return;

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Fee Structure Details", 14, 20);

    doc.autoTable({
      startY: 30,
      head: [["Class", "Student Type", "Medium", "Total Fees"]],
      body: [[
        feeStructure.class,
        feeStructure.studentType,
        feeStructure.medium,
        `₹${feeStructure.totalfees}`,
      ]],
    });

    const feeHeadData = Object.entries(feeStructure.feeHeadValues || {}).map(
      ([key, value]) => [key, `₹${value}`]
    );

    if (feeHeadData.length) {
      doc.autoTable({
        startY: doc.previousAutoTable.finalY + 10,
        head: [["Fee Head", "Amount"]],
        body: feeHeadData,
      });
    }

    const monthData = Object.entries(feeStructure)
      .filter(([key]) => key.startsWith("month"))
      .map(([key, value]) => [key, `₹${value}`]);

    if (monthData.length) {
      doc.autoTable({
        startY: doc.previousAutoTable.finalY + 10,
        head: [["Month", "Amount"]],
        body: monthData,
      });
    }

    doc.save(`fee_structure_${feeStructure.class}.pdf`);
  };

  if (!feeStructure) {
    return <div className="p-6">Loading...</div>;
  }

  const {
    class: className,
    studentType,
    totalfees,
    medium,
    feeHeadValues,
    ...months
  } = feeStructure;

  return (
    <div ref={printRef} className="container mx-auto p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Fee Structure Details</h2>
        <button onClick={() => navigate(-1)}>✖</button>
      </div>

      <table className="w-full text-sm mb-6">
        <tbody>
          <tr><td className="font-semibold">Class</td><td>{className}</td></tr>
          <tr><td className="font-semibold">Student Type</td><td>{studentType}</td></tr>
          <tr><td className="font-semibold">Medium</td><td>{medium}</td></tr>
          <tr><td className="font-semibold">Total Fees</td><td>₹{totalfees}</td></tr>

          {feeHeadValues &&
            Object.entries(feeHeadValues).map(([key, value]) => (
              <tr key={key}>
                <td className="font-semibold">{key}</td>
                <td>₹{value}</td>
              </tr>
            ))}
        </tbody>
      </table>

      <h3 className="font-bold mb-2">Monthly Fees</h3>
      <table className="w-full text-sm">
        <tbody>
          {Object.entries(months)
            .filter(([key]) => key.startsWith("month"))
            .map(([key, value]) => (
              <tr key={key}>
                <td className="font-semibold">{key}</td>
                <td>₹{value}</td>
              </tr>
            ))}
        </tbody>
      </table>

      <div className="flex justify-end mt-4 gap-3">
        <button
          onClick={handlePDF}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          Generate PDF
        </button>
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-red-600 text-white rounded"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default FeeStructurePage;
